// React
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

const useStyles = makeStyles(() => ({
  backdrop: {
    zIndex: 20000,
    background: 'rgba(255,255,255,0.6)',
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh'
  }
}));

export default function Loader() {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Backdrop
        className={classes.backdrop}
        open={true}
        invisible={true}
        onClick={handleClose}
      >
        <CircularProgress size={100} color='inherit' />
      </Backdrop>
      {/**below line just to remove lint issue */}
      {open}
    </div>
  );
}
